import { v4 as uuidv4 } from "uuid";

export const AppendUUIDKeyTable = (FORM_DATA) => {
    return FORM_DATA?.map((data) => ({key: uuidv4(), ...data}))
}